import $ from "jquery";
import "slick-carousel";

function initCustomerQuotes() {
  if ($(".js-customer-quotes").length) {
    const customerQuotes = $(".js-customer-quotes");

    customerQuotes.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      fade: true,
      infinite: true,
      nextArrow:
        '<button type="button" class="slick-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.9931 12L8.45277 5.42079L9.60015 4.45459L15.9541 12L9.60015 19.5454L8.45277 18.5792L13.9931 12Z" fill="white"/></svg></button>',
      prevArrow:
        '<button type="button" class="slick-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.0069 12L15.5472 5.42079L14.3999 4.45459L8.0459 12L14.3999 19.5454L15.5472 18.5792L10.0069 12Z" fill="white"/></svg></button>',
      responsive: [
        {
          breakpoint: 960,
          settings: {
            arrows: false,
            dots: true,
            fade: false,
            infinite: false,
          },
        },
      ],
    });
  }
}

// Run the function when the document is ready AND images are loaded
$(() => {
  initCustomerQuotes();

  // Reinitialize slider on window resize
  let resizeTimer;
  $(window).on("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if ($(".js-customer-quotes").length) {
        $(".js-customer-quotes").slick("unslick");
        initCustomerQuotes();
      }
    }, 250);
  });
});
